import { Link } from 'react-router-dom'
import { trackOutboundClick } from '../analytics'
import { BrandMark } from './BrandMark'
import { useShopLinks } from '../hooks/useShopLinks'
import { useLocale } from '../i18n/LocaleContext'

export function Footer() {
  const { t, localePath } = useLocale()
  const shopLinks = useShopLinks()
  const year = new Date().getFullYear()

  return (
    <footer className="site-footer">
      <div className="footer-newsletter">
        <div className="footer-newsletter-inner">
          <BrandMark variant="onDark" size="md" alt="" />
          <h2>{t.footerNewsletter}</h2>
          <p>{t.footerNewsletterText}</p>
          <Link to={localePath('/links')} className="btn btn-primary">
            {t.footerNewsletterCta}
          </Link>
        </div>
      </div>

      <div className="footer-main">
        <div className="footer-grid">
          <div className="footer-col">
            <h3>{t.siteName}</h3>
            <p>{t.footerAbout}</p>
          </div>
          <div className="footer-col">
            <h3>{t.footerExplore}</h3>
            <ul>
              <li>
                <Link to={localePath('/')}>{t.navHome}</Link>
              </li>
              <li>
                <Link to={localePath('/hand-drawn-originals')}>
                  {t.navOriginalArtworks}
                </Link>
              </li>
              <li>
                <Link to={localePath('/prints')}>{t.navPrints}</Link>
              </li>
              <li>
                <Link to={localePath('/miniatures')}>{t.navMiniatures}</Link>
              </li>
              <li>
                <Link to={localePath('/files')}>{t.navFiles}</Link>
              </li>
              <li>
                <Link to={localePath('/links')}>{t.navLinks}</Link>
              </li>
            </ul>
          </div>
          <div className="footer-col">
            <h3>{t.globalShops}</h3>
            <ul>
              {shopLinks.map((link) => (
                <li key={link.id}>
                  <a
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() =>
                      trackOutboundClick({
                        linkUrl: link.url,
                        itemType: 'footer_shop',
                        linkId: link.id,
                        linkLabel: link.label,
                      })
                    }
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <p className="footer-copy">
          © {year} {t.siteName}. {t.footerRights}
        </p>
      </div>
    </footer>
  )
}
